export default "__VITE_ASSET__43944fa4__"